import * as types from './types';
export default {
  [types.SET_ORDER_FORM_ID](state, payload) {
    state.orderFormId = payload;
  }
};